export const AppSidebar = {
  flow: 'y',
  width: 'G',
  minWidth: 'G',
  alignSelf: 'stretch',
  color: 'title',
  overflow: 'hidden',
  padding: '- Z X2 X2',
  gap: 'Z',
  fontSize: 'Z',

  childExtends: 'CommonCard',

  childProps: {
    flow: 'y',
  },
}

// Sidebar people group — caption + list of `AppPersonRow`s. Used inside
// `PeopleSection`, same contract as governance calendar sidebar:
//   PeopleSection: {
//     TeamGroup: { extends: 'PeopleGroup', label: 'TEAM', groupName: 'team' }
//   }
export const PeopleGroup = {
  flow: 'y',
  gap: 'Z',
  marginBottom: 'Z1',

  CaptionTitle: {
    fontSize: 'Y2',
    Text: {
      text: (el) => el.parent?.parent?.label || ''
    }
  },

  List: {
    flow: 'y',
    gap: 'Y',
    childExtends: 'AppPersonRow',
    childrenAs: 'state',
    children: (el, s) => {
      const group = el.parent.groupName
      const fn = group === 'team' ? 'activeMembers' : 'peopleByShareClass'
      return el.call(fn, group) || []
    }
  }
}

export const AppPersonRow = {
  flow: 'x',
  align: 'center left',
  gap: 'Z',
  padding: 'Z Z1',
  margin: '- -Z1',
  round: 'Z',
  fontSize: 'Z1',
  cursor: 'pointer',
  attr: {
    'data-personrow': 'true',
    'data-email': (el, s) => (s && (s.email || s.user?.email)) || ''
  },
  ':hover': { background: 'overlay' },

  Avatar: {
    avatarType: 'initials',
    boxSize: 'B1 B1',
    src: (el, s) => el.call('avatarUrl', s && (s.name || s.user?.name))
  },

  Info: {
    flow: 'y',
    gap: 'V',
    flex: '1',
    minWidth: '0',
    overflow: 'hidden',

    Name: {
      tag: 'span',
      fontSize: 'Z2',
      color: 'title',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => s?.name || s?.user?.name || s?.email || s?.user?.email || ''
    },
    Caption: {
      tag: 'span',
      fontSize: 'Y2',
      color: 'caption',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => s?.position || s?.role || s?.membership?.role || ''
    }
  }
}
